import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText
} from '@mui/material'
import React from 'react'

import InfoIcon from '@mui/icons-material/Info'

interface ListItemInfoProps {
  primary: string
  secondary: string
}

export const ListItemInfo: React.FC<ListItemInfoProps> = ({
  primary,
  secondary
}) => {
  return (
    <ListItem>
      <ListItemAvatar>
        <Avatar>
          <InfoIcon />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={primary}
        secondary={secondary}
        primaryTypographyProps={{ component: 'h5', variant: 'h5' }}
      />
    </ListItem>
  )
}
